import { Component, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  @BlockUI() blockUI!: NgBlockUI;
  constructor() { }

  ngOnInit(): void {
    this.blockUI.reset();
  }

}
